require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _TextInputOutlined = _interopRequireDefault(require("./TextInputOutlined"));

var _TextInputFlat = _interopRequireDefault(require("./TextInputFlat"));

var _theming = require("../../core/theming");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/TextInput/TextInput.tsx";
var BLUR_ANIMATION_DURATION = 180;
var FOCUS_ANIMATION_DURATION = 150;

var TextInput = function (_React$Component) {
  (0, _inherits2["default"])(TextInput, _React$Component);

  function TextInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, TextInput);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(TextInput)).call.apply(_getPrototypeOf2, [this].concat(_args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      labeled: new _reactNative.Animated.Value((_this.props.value !== undefined ? _this.props.value : _this.props.defaultValue) ? 0 : 1),
      error: new _reactNative.Animated.Value(_this.props.error ? 1 : 0),
      focused: false,
      placeholder: '',
      value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue,
      labelLayout: {
        measured: false,
        width: 0,
        height: 0
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "ref", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showPlaceholder", function () {
      if (_this.timer) {
        clearTimeout(_this.timer);
      }

      _this.timer = setTimeout(function () {
        return _this.setState({
          placeholder: _this.props.placeholder
        });
      }, 50);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hidePlaceholder", function () {
      return _this.setState({
        placeholder: ''
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "timer", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "root", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showError", function () {
      var scale = _this.props.theme.animation.scale;

      _reactNative.Animated.timing(_this.state.error, {
        toValue: 1,
        duration: FOCUS_ANIMATION_DURATION * scale,
        useNativeDriver: _reactNative.Platform.select({
          ios: false,
          "default": true
        })
      }).start(_this.showPlaceholder);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hideError", function () {
      var scale = _this.props.theme.animation.scale;

      _reactNative.Animated.timing(_this.state.error, {
        toValue: 0,
        duration: BLUR_ANIMATION_DURATION * scale,
        useNativeDriver: _reactNative.Platform.select({
          ios: false,
          "default": true
        })
      }).start();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "restoreLabel", function () {
      var scale = _this.props.theme.animation.scale;

      _reactNative.Animated.timing(_this.state.labeled, {
        toValue: 1,
        duration: FOCUS_ANIMATION_DURATION * scale,
        useNativeDriver: _reactNative.Platform.select({
          ios: false,
          "default": true
        })
      }).start();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "minimizeLabel", function () {
      var scale = _this.props.theme.animation.scale;

      _reactNative.Animated.timing(_this.state.labeled, {
        toValue: 0,
        duration: BLUR_ANIMATION_DURATION * scale,
        useNativeDriver: _reactNative.Platform.select({
          ios: false,
          "default": true
        })
      }).start();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleFocus", function (args) {
      if (_this.props.disabled || !_this.props.editable) {
        return;
      }

      _this.setState({
        focused: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(args);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleBlur", function (args) {
      if (_this.props.disabled || !_this.props.editable) {
        return;
      }

      _this.setState({
        focused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(args);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChangeText", function (value) {
      if (!_this.props.editable) {
        return;
      }

      _this.setState({
        value: value
      });

      _this.props.onChangeText && _this.props.onChangeText(value);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleLayoutAnimatedText", function (e) {
      _this.setState({
        labelLayout: {
          width: e.nativeEvent.layout.width,
          height: e.nativeEvent.layout.height,
          measured: true
        }
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(TextInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.focused !== this.state.focused || prevState.value !== this.state.value || prevState.labelLayout !== this.state.labelLayout) {
        if (this.state.value || this.state.focused) {
          this.minimizeLabel();
        } else {
          this.restoreLabel();
        }
      }

      if (prevState.focused !== this.state.focused || prevProps.label !== this.props.label) {
        if (this.state.focused || !this.props.label) {
          this.showPlaceholder();
        } else {
          this.hidePlaceholder();
        }
      }

      if (prevProps.error !== this.props.error) {
        if (this.props.error) {
          this.showError();
        } else {
          this.hideError();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    }
  }, {
    key: "setNativeProps",
    value: function setNativeProps(args) {
      return this.root && this.root.setNativeProps(args);
    }
  }, {
    key: "isFocused",
    value: function isFocused() {
      return this.root && this.root.isFocused();
    }
  }, {
    key: "clear",
    value: function clear() {
      return this.root && this.root.clear();
    }
  }, {
    key: "focus",
    value: function focus() {
      return this.root && this.root.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      return this.root && this.root.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _ref = this.props,
          mode = _ref.mode,
          rest = (0, _objectWithoutProperties2["default"])(_ref, ["mode"]);
      return mode === 'outlined' ? React.createElement(_TextInputOutlined["default"], (0, _extends2["default"])({}, rest, {
        value: this.state.value,
        parentState: this.state,
        innerRef: function innerRef(ref) {
          _this2.root = ref;
        },
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChangeText: this.handleChangeText,
        onLayoutAnimatedText: this.handleLayoutAnimatedText,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 416
        }
      })) : React.createElement(_TextInputFlat["default"], (0, _extends2["default"])({}, rest, {
        value: this.state.value,
        parentState: this.state,
        innerRef: function innerRef(ref) {
          _this2.root = ref;
        },
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChangeText: this.handleChangeText,
        onLayoutAnimatedText: this.handleLayoutAnimatedText,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 429
        }
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      return {
        value: typeof nextProps.value !== 'undefined' ? nextProps.value : prevState.value
      };
    }
  }]);
  return TextInput;
}(React.Component);

(0, _defineProperty2["default"])(TextInput, "defaultProps", {
  mode: 'flat',
  dense: false,
  disabled: false,
  error: false,
  multiline: false,
  editable: true,
  render: function render(props) {
    return React.createElement(_reactNative.TextInput, (0, _extends2["default"])({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 174
      }
    }));
  }
});

var _default = (0, _theming.withTheme)(TextInput);

exports["default"] = _default;